import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Styled from './TextWithParsedLinks.styled';

const urlRegex = /(?:https?:\/\/|www\.)[^\s]+/gi;

const TextWithParsedLinks = ({ text, contrast }) => {
  const parsedTextArray = useMemo(() => {
    const matches = [];
    let lastIndex = 0;

    for (const match of text.matchAll(urlRegex)) {
      const start = match.index;
      if (start > lastIndex) {
        matches.push({ text: text.slice(lastIndex, start), isLink: false });
      }
      matches.push({ text: match[0], isLink: true });
      lastIndex = start + match[0].length;
    }

    if (lastIndex < text.length) {
      matches.push({ text: text.slice(lastIndex), isLink: false });
    }

    return matches;
  }, [text]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
  }, []);
  return (
    <>
      {parsedTextArray.reduce((acc, slice, index) => {
        const element = slice.isLink ? (
          <Styled.ParsedLink
            key={index}
            $contrast={contrast}
            onClick={handleClick}
            rel="noopener noreferrer"
            target="_blank"
            href={
              slice.text.startsWith('www.')
                ? `https://${slice.text}`
                : slice.text
            }
          >
            {slice.text}
          </Styled.ParsedLink>
        ) : (
          <React.Fragment key={index}>{slice.text}</React.Fragment>
        );

        // Add a space before this element if it's not the first
        if (index !== 0) acc.push(' ');
        acc.push(element);
        return acc;
      }, [])}
    </>
  );
};

TextWithParsedLinks.propTypes = {
  text: PropTypes.string.isRequired,
};

export default TextWithParsedLinks;
